import React from 'react';

import { EventStreamHeaderProps } from './interfaces';

const EventStreamHeader = ({ as: Component, title }: EventStreamHeaderProps) => {
  return (
    <Component className="m-0 font-suisse-works text-headline-xxs md:text-headline-xs lg:text-headline-sm">
      {title}
    </Component>
  );
};

export default EventStreamHeader;
